export const keepDigits = (value: string) => value.replaceAll(/\D/g, '');
